import {productGroupCreationErrorSchema, ProductGroupCreationErrorType} from './product-group-form-type';

export function isProductGroupCreationErrorType(jsonData: unknown): jsonData is ProductGroupCreationErrorType {
    return productGroupCreationErrorSchema.safeParse(jsonData).success;
}
